import {
    HttpLink,
    type HttpOptions,
    type UriFunction,
} from '@apollo/client/core';
import { BatchHttpLink } from '@apollo/client/link/batch-http';

type HttpLinkBatchOptions = {
    enabled?: boolean;
    max?: number;
    debounce?: boolean;
    interval?: number;
};

export interface HttpLinkOptions extends Omit<HttpOptions, 'uri'> {
    url: string | UriFunction;
    batch?: HttpLinkBatchOptions;
}

export function makeHttpLink(
    options: HttpLinkOptions
): HttpLink | BatchHttpLink {
    if (options.batch?.enabled) {
        return new BatchHttpLink({
            batchMax: options.batch.max,
            batchInterval: options.batch.interval,
            batchDebounce: options.batch.debounce,
            ...options,
            uri: options.url,
        });
    } else {
        return new HttpLink({
            ...options,
            uri: options.url,
        });
    }
}
